module.exports = __webpack_public_path__ + "media/images/v3/s_3-f6be2de1113da386ea88569243a37113.png";